export default function hideValue() {
  'ngInject';

  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ngModel) {
      $ngModel.$formatters.push((value) => (String(value) === $attrs.hideValue ? null : value));
    },
  };
}
